import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  .box-select {
    display: flex;
    margin-bottom: 8px;
    flex-wrap: wrap;
    align-items: flex-start;
    .ant-form-item {
      margin-bottom: 0;
      &.input-onsite {
        display: flex;
        align-items: center;
      }
    }
    .ant-checkbox-wrapper {
      display: flex;
      align-items: center;
      .ant-checkbox {
        top: 0;
      }
    }
  }
  .titleSiteName {
    margin-left: 8px;
    color: #000000;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
  }
  .group-input {
    padding: 0 24px 16px 24px;
    .ant-form-item {
      flex-direction: row;
      display: flex;
      &.note-field {
        margin-bottom: 0;
      }
      .ant-form-item-label {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 0;
        .ant-form-item-no-colon {
          color: #000000;
          min-width: 110px;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 24px;
        }
      }
    }
    .select-field {
      min-width: 400px;
    }
  }
  .ant-modal-footer {
    .ant-btn-primary {
      margin-left: 16px !important;
    }
  }

  .select-date {
    width: 177px;
  }
  .center-text {
    display: flex;
    align-items: center;
    padding: 0 16px 0 16px;
  }
  .ant-form-item-explain-error {
    max-width: 170px;
  }
`;

export const HeaderStyle = styled.div`
  display: flex;
  flex-direction: row;
  img {
    margin-right: 16px;
  }
`;
